import { isObject } from 'lodash'
import React from 'react'
import useCSSForHeight from '../../../hook/UseCSSForHeight'
import { icon } from '../../../services/icon'

/**
 *
 * @param {Object} children
 * @param {Boolean} defaultOpen
 * @param {String} title
 * @param {Function} icon
 * @param {Function} onClickOpen
 * @param {String} className
 * @param {Boolean} isOpen
 * @param {Number} index
 * @returns {JSX.Element}
 * @description Dropdown component
 */

const Dropdown = ({
    children,
    defaultOpen = false,
    title,
    beforeIcon = null,
    onClickOpen,
    className,
    isOpen,
    index = null,
    variable,
}) => {
    const ref = useCSSForHeight(variable)

    // Condition to open the dropdown
    const conditionOpeningDropdown = React.useMemo(() => {
        if (index !== null) {
            if (isObject(isOpen)) {
                return isOpen?.index?.includes(index)
            } else {
                return isOpen === index
            }
        } else {
            return isOpen
        }
    }, [index, isOpen])

    // Return the classnames
    const classNames = React.useMemo(() => {
        return {
            icon: conditionOpeningDropdown
                ? 'baseocom-chevron baseocom-rotate'
                : 'baseocom-chevron',
            div:
                conditionOpeningDropdown || defaultOpen
                    ? `baseocom-open baseocom-dropdown-content`
                    : 'baseocom-dropdown-content',

            btn:
                conditionOpeningDropdown || defaultOpen
                    ? 'baseocom-btn baseocom-dropdown-btn baseocom-dropdown-btn-open'
                    : 'baseocom-btn baseocom-dropdown-btn',
        }
    }, [conditionOpeningDropdown])

    return (
        <div className={`${className} baseocom-dropdown`}>
            <button disabled={defaultOpen} className={classNames.btn} onClick={onClickOpen}>
                <div className="baseocom-arrow-text">
                    {beforeIcon && beforeIcon()}
                    <span className="baseocom-text">{title}</span>
                </div>
                {!defaultOpen ? (
                    <span className={classNames.icon}>{icon('chevron-down')}</span>
                ) : null}
            </button>
            <div
                ref={ref}
                className={classNames.div}
                style={{
                    maxHeight:
                        conditionOpeningDropdown || defaultOpen ? 'var(--' + variable + ')' : 0,
                }}
            >
                {children}
            </div>
        </div>
    )
}

export default Dropdown
